import styled from "styled-components";
import { borderRadius, fontSizes, lineHeights, spacing, typographyMixin } from "@magicbi/ui-library";

export const Message = styled.p`
  margin: 0;
  ${typographyMixin("body", 4)}
  font-size: ${fontSizes["13"]};
  line-height: ${lineHeights["20"]};
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const List = styled.ul`
  display: grid;
  gap: ${spacing[1]};
  margin: 0;
  padding: ${spacing[2]} ${spacing[3]};
  list-style: none;
  border: 1px solid ${({ theme }) => theme.colors.border.stroke};
  border-radius: ${borderRadius.md};
  background: ${({ theme }) => theme.colors.surface.secondary};
  ${typographyMixin("body", 4)}
  overflow-wrap: anywhere;
`;

export const More = styled.li`
  color: ${({ theme }) => theme.colors.text.secondary};
`;
